import React, { useEffect } from 'react';
import BookingWalkthrough from './BookingWalkthrough';
import Gallery from './Gallery';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Footer from './Footer';

const BookNowCoatingPage = () => {
  // Meta Pixel ViewContent tracking for Coating Book Now page
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_type: 'product',
        content_name: 'Book Now Coating Page - Pro-Wash Mobile Detailing',
        content_category: 'Ceramic Coating Booking',
        value: 799,
        currency: 'CAD'
      });
    }
  }, []);

  return (
    <div>
      {/* Hidden SEO content - invisible but crawlable */}
      <div className="sr-only">
        <h1>Book Your Ceramic Coating</h1>
        <p>Premium 5-year ceramic coating in Abbotsford, BC</p>
      </div>

      {/* All homepage sections except Hero - with coating prioritized */}
      <BookingWalkthrough coatingFirst={true} />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
};

export default BookNowCoatingPage;
